export default __webpack_public_path__ + "static/media/network4.07d5bc51.svg";